import { httpCreate, preferVal } from './http';

const http = httpCreate('/wx');

// prefer 四种值
// 1、secret：优先查找配置的appid和appsecret，如果没有配置，会查找是否有第三方授权，使用第三方授权的
// 2、secretonly：在后台appid和appsecret配置过（如果不是映目域名）
// 3、third：优先查找第三方授权，如果没有，查找appid和appsecret的配置（默认）
// 4、thirdonly：只查找第三方授权
// 只需要判断是为m.inmuu.com域名
export const wx = {
	config(appid, url) {
		return http.get(`/utils/signature/${appid}`, {
			params: {
				url,
				prefer: preferVal(),
			},
			baseURL: location.origin + '/wx',
		});
	},
};
